import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=97a1d104&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=97a1d104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1d104",
  null
  
)

export default component.exports